<form [formGroup]="formulario" (submit)="enviarMensagem()" style="margin-top: 100px;">
  <input #nomeInput formControlName="mensagem" class="previmil__campo" placeholder="Mensagem">
  <input #nomeInput *ngIf="formulario.get('tipoMensagem').value == 'usuario'" formControlName="destinatario" class="previmil__campo" placeholder="destinatario">
  <select #nomeInput formControlName="endpoint" class="previmil__campo" placeholder="Mensagem">
    <option value="toastr">Toastr</option>
    <option value="teste">Teste</option>
  </select>
  <select #nomeInput formControlName="tipoMensagem" class="previmil__campo" placeholder="Mensagem">
    <option value="usuario">Usuário</option>
    <option value="broadcast">Broadcast</option>
  </select>
  <button type="submit" class="previmil__botão_padrao botao_pequeno">ENVIAR</button>
</form>

<span>{{resposta}}</span>